module.exports = __webpack_public_path__ + "img/device.f0fa6f1a.svg";